export type Lang = 'de' | 'en';

const strings: Record<string, Record<Lang, string>> = {
  // CoverSection
  'cover.start': { de: 'Start', en: 'Start' },
  'cover.loading': { de: 'Lädt', en: 'Loading' },
  'cover.scrollToBegin': { de: 'Scrolle um zu starten', en: 'Scroll to begin' },

  // Colophon — section headers (reused from app/ footer.json where matching)
  'colophon.by': { de: 'Von', en: 'By' },
  'colophon.theByline': { de: 'Der Autor', en: 'The byline' },
  'colophon.published': { de: 'Veröffentlicht', en: 'Published' },
  'colophon.scrolls': { de: 'Scrolls', en: 'scrolls' },
  'colophon.readBy': { de: 'Gelesen von', en: 'Read by' },
  'colophon.people': { de: 'Lesern', en: 'people' },
  'colophon.credits': { de: 'Credits', en: 'Credits' },
  'colophon.sources': { de: 'Quellen', en: 'Sources' },
  'colophon.contact': { de: 'Kontakt', en: 'Contact' },

  // Colophon — abbinder
  'colophon.scrolledOn': { de: 'Gescrollt auf', en: 'Scrolled on' },
  'colophon.publishOwn': { de: 'Eigenen veröffentlichen →', en: 'Publish your own →' },
  'colophon.publishOwnStory': {
    de: 'Veröffentliche deine eigene scrollbare Story →',
    en: 'Publish your own scrollable story →',
  },

  // Colophon — legal links (from app/ footer.json)
  'colophon.imprint': { de: 'Impressum', en: 'Imprint' },
  'colophon.privacy': { de: 'Datenschutz', en: 'Privacy' },
  'colophon.terms': { de: 'AGB', en: 'Terms' },

  // ViewerChrome — aria-labels + interaction
  'viewer.close': { de: 'Schließen', en: 'Close' },
  'viewer.like': { de: 'Gefällt mir', en: 'Like' },
  'viewer.unlike': { de: 'Gefällt mir entfernen', en: 'Unlike' },
  'viewer.liked': { de: 'Gefällt dir', en: 'Liked' },
  'viewer.save': { de: 'Speichern', en: 'Save' },
  'viewer.unsave': { de: 'Gespeichert entfernen', en: 'Unsave' },
  'viewer.saved': { de: 'Gespeichert', en: 'Saved' },
  'viewer.share': { de: 'Teilen', en: 'Share' },

  // ViewerChrome — overflow menu
  'viewer.actions': { de: 'Aktionen', en: 'Actions' },

  // UpNextInline
  'upnext.eyebrow': { de: 'Scroll weiter', en: 'Keep scrolling' },
  'upnext.heading': { de: 'Mehr von Scrolly', en: 'More from Scrolly' },
};

export function t(key: string, lang: Lang): string {
  return strings[key]?.[lang] ?? strings[key]?.en ?? key;
}
